import React from 'react';
import { Image, StyleSheet } from 'react-native';
import { rem } from 'design-system';
import useColors from 'hooks/useColors';
const staticStyles = StyleSheet.create({
    alpacaImg: {
        height: rem(20),
        aspectRatio: 3.4,
    },
    secclImg: {
        height: rem(20),
        aspectRatio: 2.6,
    },
});
const AlpacaImg = ({ tintColor }) => (<Image source={require('../img/alpaca.png')} style={staticStyles.alpacaImg} resizeMode="contain" tintColor={tintColor}/>);
export const SecclImg = ({ tintColor }) => (<Image source={require('../img/seccl.png')} style={staticStyles.secclImg} resizeMode="contain" tintColor={tintColor}/>);
export const useGetBrokerImage = () => {
    const colors = useColors();
    const getBrokerImage = (broker) => {
        if (broker === 'alpaca') {
            return <AlpacaImg tintColor={colors.text.primary}/>;
        }
        return null;
    };
    return getBrokerImage;
};
